import { createFileRoute } from "@tanstack/react-router";
import { TenantPlanTab } from "../features/plans/pages/tenant-plan-tab";

export const Route = createFileRoute("/tenants/$tenantId/plan")({
  component: TenantPlanTab,
});
